import(/* webpackMode: "eager" */ "/Users/dipnerreddy/Desktop/portfolio-main/app/global-error.jsx")